import { useState } from 'react';
import Button from '../Button.js';
import Field, { validateFields } from './Field.js';
import StepFrame from './StepFrame.js';

/*
 * FormStep
 *
 * A group of fields answered together, the device facts at the top of a tree,
 * and identity and address inside the escalation.
 *
 * Values are seeded from the answers already gathered, which is what makes Back
 * non-destructive: returning to a form finds it as it was left rather than
 * blank. Fields are grouped rather than asked one at a time because a name, an
 * email and a phone number are one act of typing, and splitting them across
 * three screens would be ceremony.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const FormStep = ({
  answers,
  node,
  onSubmit,
  stepKey
}) => {
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [values, setValues] = useState(() => {
    return (node.fields || []).reduce((seed, field) => {
      return {
        ...seed,
        [field.id]: answers?.[field.id] ?? ''
      };
    }, {});
  });
  const onChange = (field, value) => {
    let next = {
      ...values,
      [field.id]: value
    };
    setValues(next);

    // Only correct live once they have tried to continue. See Field.js.
    if (submitted) {
      setErrors(validateFields(node.fields, next));
    }
  };
  const onContinue = () => {
    setSubmitted(true);
    let found = validateFields(node.fields, values);
    setErrors(found);
    if (Object.keys(found).length > 0) {
      document.getElementById(Object.keys(found)[0])?.focus();
      return;
    }
    onSubmit(values);
  };

  // Enter submits from any single-line field, as it would in a real form.
  const onKeyDown = event => {
    if (event.key === 'Enter' && event.target.tagName !== 'TEXTAREA') {
      event.preventDefault();
      onContinue();
    }
  };
  return /*#__PURE__*/_jsx(StepFrame, {
    actions: /*#__PURE__*/_jsx(Button, {
      label: node.action || 'Continue',
      onClick: onContinue
    }),
    eyebrow: node.eyebrow,
    footnote: node.footnote,
    help: node.help,
    stepKey: stepKey,
    title: node.title,
    children: /*#__PURE__*/_jsx("div", {
      onKeyDown: onKeyDown,
      children: (node.fields || []).map(field => /*#__PURE__*/_jsx(Field, {
        error: errors[field.id],
        field: field,
        onChange: onChange.bind(this, field),
        value: values[field.id]
      }, field.id))
    })
  });
};
export default FormStep;